// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1ATOE","large":"styles_large__3_ijd"};